module.exports = __webpack_public_path__ + "static/media/profileNew.4acebaf9.png";